import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Controller, useFormContext } from "react-hook-form";
import { SectionDefinition } from "api/factories/form.factory";
import { getLocaleDateFormat } from "utils";

export const DatePicker = ({ name, translation, value: defaultDate }: SectionDefinition) => {
    const { control, setValue } = useFormContext();

    return (
        <Controller
            defaultValue={defaultDate ? new Date(defaultDate) : null}
            name={name}
            control={control}
            render={({ value }) => {
                return (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            inputVariant="outlined"
                            autoOk
                            fullWidth
                            variant="inline"
                            format={getLocaleDateFormat()}
                            margin="none"
                            label={translation}
                            value={value}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(date) => setValue(name, date, { shouldDirty: true })}
                        />
                    </MuiPickersUtilsProvider>
                );
            }}
        />
    );
};
